import * as types from './mutation-types'
import AuthRepository from '../data/auth.repository'
import PackageRepository from '../data/package.repository'
import ProductRepository from '../data/product.repository'

export default {
  login (context, data) {
    return new Promise((resolve, reject) => {
      AuthRepository.login(data.email, data.password)
        .then((response) => {
          localStorage.setItem('sts_token', response.token)
          context.commit(types.SET_USER, response.user)
          resolve(response.user)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  logout (context, data) {
    localStorage.removeItem('sts_token')
    context.commit(types.SET_USER)
  },
  getStoredUser (context, data) {
    const token = localStorage.getItem('sts_token')
    if (!token) {
      return context.commit(types.SET_USER, null)
    } else {
      return AuthRepository.get(token)
        .then((user) => {
          return context.commit(types.SET_USER, user)
        })
        .catch(() => {
          localStorage.removeItem('sts_token')
          return context.commit(types.SET_USER, null)
        })
    }
  },
  getPackages (context, data) {
    PackageRepository.get().then((ps) => {
      context.commit(types.SET_PACKAGES, ps)
    })
  },
  setCurrentPackage (context, data) {
    context.commit(types.SET_PACKAGE, data)
  },

  // Product actions
  getProducts (context) {
    return ProductRepository.getAll().then((products) => {
      context.commit(types.SET_PRODUCTS, products)
      return products
    })
  },
  setCurrentProduct (context, product) {
    context.commit(types.SET_CURRENT_PRODUCT, product)
  },

  // Cart actions
  loadCart (context) {
    const cart = localStorage.getItem('sts_cart')
    if (cart) {
      context.commit(types.SET_CART, JSON.parse(cart))
    }
  },
  addToCart (context, item) {
    context.commit(types.ADD_TO_CART, item)
    localStorage.setItem('sts_cart', JSON.stringify(context.state.cart))
  },
  removeFromCart (context, variantId) {
    context.commit(types.REMOVE_FROM_CART, variantId)
    localStorage.setItem('sts_cart', JSON.stringify(context.state.cart))
  },
  updateCartItem (context, payload) {
    context.commit(types.UPDATE_CART_ITEM, payload)
    localStorage.setItem('sts_cart', JSON.stringify(context.state.cart))
  },
  clearCart (context) {
    context.commit(types.CLEAR_CART)
    localStorage.removeItem('sts_cart')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js